import { Button } from '@cmctechnology/phoenix-stockbroking-web-design';
import styled from 'styled-components';

export const InlineButton = styled(Button)`
  display: inline;
  margin-right: 2em;
  max-width: 11em;
`;
